import { Platform, StyleSheet } from 'react-native';

import { spacing, colors } from '@pletly/ui';
import { CreateResponsiveStyle, DEVICE_SIZES, minSize } from 'rn-responsive-styles';

const styles = StyleSheet.create({
	root: {
		paddingVertical: spacing(2),
	},
	withBackground: {
		...Platform.select({
			web: {
				backgroundColor: colors.white,
				borderRadius: 12,
				marginVertical: spacing(1),
			},
			default: {},
		}),
	},
	fromOrganisation: {
		...Platform.select({
			web: {
				backgroundColor: colors.primary100,
			},
			default: {},
		}),
	},
	notConfirmed: {
		opacity: 0.7,
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexDirection: 'row',
		marginVertical: spacing(),
		paddingHorizontal: spacing(),
	},
	flexRowCenter: {
		flexDirection: 'row',
		alignItems: 'center',
	},
	flexShrink: {
		flexShrink: 1,
	},
	pinnedIcon: {
		marginLeft: spacing(),
	},
	menusRight: {
		flexDirection: 'row',
		alignItems: 'center',
		alignSelf: 'flex-start',
		gap: spacing(),
	},
	avatar: {
		marginRight: spacing(),
		alignSelf: 'flex-start',
	},
	actions: {
		flex: 1,
		flexDirection: 'row',
		paddingHorizontal: spacing(),
		...Platform.select({
			web: {
				paddingBottom: spacing(3),
				flex: undefined,
			},
			default: {},
		}),
	},
	commentStyle: {
		paddingHorizontal: 0,
	},
	reactionContainer: {
		flexDirection: 'row',
		alignItems: 'center',
		marginRight: spacing(2),
		opacity: 1,
	},
	pressed: {
		opacity: 0.5,
	},
	reactionCount: {
		marginLeft: spacing(),
	},
	username: Platform.select({
		web: {
			/**
			 * Web line height for `h4` is 23.4 computed which results in XX.4 pixel height of post element.
			 * Flashlist (probably) rounds item height to integer, which results in a few pixels lost
			 * in container height and shows additional scroll (e.g.  5 items * 120.4px = 602px, but container height is 600px)
			 */

			lineHeight: 23,
		},
		default: {},
	}),
	users: { flexDirection: 'row', alignItems: 'center', gap: spacing() },
});

export const useStyles = CreateResponsiveStyle(styles, {
	[minSize(DEVICE_SIZES.MEDIUM_DEVICE)]: {
		withBackground: {
			...Platform.select({
				web: {
					padding: spacing(3),
				},
				default: {},
			}),
		},
	},
});
